export default __webpack_public_path__ + "static/media/signPost.792f8f0e.png";